import React, { useState } from 'react';

import Text from '@sats-group/ui-lib/react/text';

import Addon from 'shared/components/addon/addon';
import Options from 'shared/components/options/options';
import Spinner from 'shared/components/spinner/spinner';
import type { NamedFC } from 'shared/types/named-fc.types';

import SplitLayout from 'ui/components/split-layout/split-layout';

import type { CustomizeMembership as Props } from './customize-membership.props';

const CustomizeMembership: NamedFC<Props> = ({
  addons,
  binding,
  gx,
  layout,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <SplitLayout {...layout}>
      <div className="customize-membership">
        {isLoading ? <Spinner theme={Spinner.themes.overlay} /> : null}
        <div className="customize-membership__options">
          {gx ? (
            <div
              className="customize-membership__option-category"
              key={gx.title}
            >
              <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
                {gx.title}
              </Text>
              <Options {...gx.options} />
            </div>
          ) : null}
          {addons ? (
            <div className="customize-membership__option-category">
              <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
                {addons.title}
              </Text>
              <div className="customize-membership__addons">
                {addons.options.map(({ addon, link }) => (
                  <Addon
                    {...addon}
                    key={link}
                    onClick={() => {
                      setIsLoading(true);
                      window.location.assign(link);
                    }}
                  />
                ))}
              </div>
            </div>
          ) : null}
          {binding ? (
            <div className="customize-membership__option-category">
              <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
                {binding.title}
              </Text>
              <Options key={binding.title} {...binding.options} />
            </div>
          ) : null}
        </div>
      </div>
    </SplitLayout>
  );
};

CustomizeMembership.displayName = 'CustomizeMembership';

export default CustomizeMembership;
